import { render, staticRenderFns } from "./EmptyRow.vue?vue&type=template&id=b1c674ae&lang=pug&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports